import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { useShopModel } from "../shopModel";
import { YhBox } from "../../../../components2/YhBox";

export const DataBox = () => {
    const { setIShopDrawer, selectedRowKeys } = useShopModel();

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setIShopDrawer("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要操作的数据");
                    return;
                }
                setIShopDrawer("edit");
            }}
        >编辑</Button>
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}